
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.9 74.4H9.7V9.7h9.6v54.9h32.6zM108.7 9.7v25.4H78.4V9.7h-9.6v64.7h9.6V44.8h30.3v29.6h9.6V9.7z"}}),_c('path',{attrs:{"opacity":".7","d":"M9.7 94.6h108.7v23.7H9.7z"}})])
          )
        }
      }
    